var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Kpay } from "../../../assets/images/paymentMethods";
import { Box, Button, Grid, InputAdornment, TextField, Typography, } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Mail } from "react-feather";
import { useKpayEmailState } from "./state/useKpayEmailState";
import { Translate as T } from "react-localize-redux";
import { useCheckoutContext } from "../../../context/useCheckoutContext";
var useStyles = makeStyles(function (theme) { return ({
    button: {
        "&:hover": {
            backgroundColor: theme.palette.primary.main,
        },
        backgroundColor: theme.palette.primary.main,
        borderRadius: 10,
        color: theme.palette.background.paper,
        height: "48px",
    },
    card: {
        minHeight: "285px",
    },
    sbuTittleLabel: {
        fontSize: 16,
    },
    textFieldRoot: {
        "& .MuiOutlinedInput-root": {
            borderRadius: 10,
        },
        marginBottom: 24,
        marginTop: 8,
    },
    kpay: {
        height: theme.spacing(4),
        width: theme.spacing(8),
    },
}); });
export var KpayEmail = function () {
    var classes = useStyles();
    var _a = useKpayEmailState(), form = _a.form, handleSubmit = _a.handleSubmit, setRulesEmail = _a.setRulesEmail;
    var isMobile = useCheckoutContext().isMobile;
    return (React.createElement(Box, { display: "flex", justifyContent: "center", flexDirection: "column", height: "100%", width: "100%", className: isMobile ? "" : classes.card, pt: !isMobile ? 5 : 2, pb: !isMobile ? 5 : 2 },
        React.createElement(Box, { display: "flex", justifyContent: "center", marginBottom: 1, pr: 3, pl: 3 },
            React.createElement(Kpay, { className: classes.kpay })),
        React.createElement(Box, { display: "flex", justifyContent: "center", marginBottom: 3, pr: 3, pl: 3 },
            React.createElement(Typography, { color: "textPrimary", className: classes.sbuTittleLabel },
                React.createElement(T, { id: "kpayEmail.subtittle" }))),
        React.createElement("form", { onSubmit: form.handleSubmit(handleSubmit) },
            React.createElement(T, null, function (_a) {
                var translate = _a.translate;
                return (React.createElement(Box, { pr: isMobile && 2, pl: isMobile && 2 },
                    React.createElement(Grid, { container: true },
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(TextField, { placeholder: translate("kpayEmail.placeholder"), name: "email", id: "email", variant: "outlined", margin: "normal", className: classes.textFieldRoot, fullWidth: true, InputProps: {
                                    startAdornment: (React.createElement(InputAdornment, { position: "start" },
                                        React.createElement(Mail, { color: "#CBD5E0" }))),
                                }, inputRef: form.register(__assign({}, setRulesEmail())), error: !!form.errors.email, helperText: !!form.errors.email && form.errors.email.message })),
                        React.createElement(Grid, { item: true, xs: 12 },
                            React.createElement(Button, { variant: "outlined", color: "primary", className: classes.button, fullWidth: true, type: "submit" },
                                React.createElement(T, { id: "kpayEmail.confirm" }))))));
            }))));
};
